import type { ApiSuccess } from '@mds/shared/types/api';
import type {
  EventRegistrationForm,
  ReplaceEventRegistrationFormRequest,
} from '@mds/shared/types/event-registration';

import { api } from '@/lib/api';

/** The questions an event asks at registration — see `backend/docs/event-registrations.md`. */

const path = (eventId: string) => `admin/events/${eventId}/registration-form`;

/** A new event starts at version 1 with the default questions; version 0 asks nothing. */
export const getForm = (eventId: string): Promise<EventRegistrationForm> =>
  api.get<ApiSuccess<EventRegistrationForm>>(path(eventId)).then((r) => r.data);

/**
 * Replaces the whole form in one go. `expectedVersion` is the version this copy
 * was loaded at; a stale one is refused rather than overwriting someone else.
 * It never locks: answers already given keep their own copy of each question.
 */
export const replaceForm = (
  eventId: string,
  body: ReplaceEventRegistrationFormRequest,
): Promise<EventRegistrationForm> =>
  api.put<ApiSuccess<EventRegistrationForm>>(path(eventId), body).then((r) => r.data);
